import {
  TekionAccessoryEntity,
  TekionEntity,
  TekionEntityType,
  TekionFeeEntity,
  TekionFNIEntity,
  TekionTaxEntity,
} from './legos/dmsTypes';

/**
 * Returns true if entities match
 * @param  {tekionEntity} - entity 1
 * @param  {tekionEntity2} - entity 2
 * @returns boolean
 */
export function areTekionEntitiesEqual(
  tekionEntity: TekionEntity,
  tekionEntity2: TekionEntity,
): boolean {
  if (
    !tekionEntity ||
    !tekionEntity2 ||
    tekionEntity.type !== tekionEntity2.type
  ) {
    return false;
  }
  switch (tekionEntity.type) {
    case TekionEntityType.FEE:
      return (
        tekionEntity.name === (tekionEntity2 as TekionFeeEntity).name
      );
    case TekionEntityType.TAX:
      return (
        tekionEntity.taxCode === (tekionEntity2 as TekionTaxEntity).taxCode
      );
    case TekionEntityType.FNI:
      return (
        tekionEntity.productId ===
          (tekionEntity2 as TekionFNIEntity).productId &&
        tekionEntity.providerId ===
          (tekionEntity2 as TekionFNIEntity).providerId
      );
    case TekionEntityType.ACCESSORY:
      return (
        tekionEntity.accessoryCode ===
          (tekionEntity2 as TekionAccessoryEntity).accessoryCode &&
        tekionEntity.accessoryId ===
          (tekionEntity2 as TekionAccessoryEntity).accessoryId
      );
    default:
      return false;
  }
}
